import type { CommandData } from '../types'

export function open() {
  const message: CommandData = {
    isFromBeeetle: true,
    command: 'open',
  }
  window.postMessage(message)
}
